import { useEffect, useState } from "react";
import { usePlayer } from "@/context/PlayerContext";
import EveilPassportModal from "./EveilPassportModal";

const SEEN_KEY = "chronos.eveil.passport.v1";
const EVEIL_IDS = [101, 102];

/**
 * Detects when the child has completed BOTH Éveil chapters and hasn't seen
 * the passport modal yet. Shows the celebration once, then never again.
 */
export default function EveilPassportWatcher() {
  const { player } = usePlayer();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!player?.id) return;
    const completed = new Set(player.levels_completed || []);
    const allDone = EVEIL_IDS.every((id) => completed.has(id));
    if (!allDone) return;
    try {
      if (localStorage.getItem(SEEN_KEY)) return;
    } catch (e) { /* ignore */ }
    // Slight delay so the level's Win modal doesn't overlap
    const t = setTimeout(() => setOpen(true), 1200);
    return () => clearTimeout(t);
  }, [player?.levels_completed]);

  return <EveilPassportModal open={open} onClose={() => setOpen(false)} player={player} />;
}
